export default __webpack_public_path__ + "static/media/Quickswap.126fc90e.png";